import script from "./jiaozhigongduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./jiaozhigongduotiao.vue?vue&type=script&setup=true&lang=js"

import "./jiaozhigongduotiao.vue?vue&type=style&index=0&id=aaed57c0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaed57c0"]])

export default __exports__